function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

// Collapsible row start
document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});
// Collapsible row end

$(document).ready(function(e){ 
  $("header .dropbtn").on("click", function () {
    if ($(this).parent().hasClass("active")) {
      $(this).parent().removeClass("active");          
    } else {
      $(".header .dropdown").removeClass("active");
      $(this).parent().addClass("active");          
    }
  });
  $(document).mouseup(function(e){
    var activeNavItems = $(".nav_item.active"), 
        popupContainer = $(".popup .popup_content"), 
        sortDropdownContainer = $(".sort_dropDown"), 
        MobfilterContainer = $(".product_filter_wpr .product_filter_group");
    if (!activeNavItems.is(e.target) && activeNavItems.has(e.target).length === 0) activeNavItems.removeClass('active');
    if (!popupContainer.is(e.target) && popupContainer.has(e.target).length === 0) $(".popup").removeClass('show'), $('body').removeClass('overflow--hidden');
    if (!sortDropdownContainer.is(e.target) && sortDropdownContainer.has(e.target).length === 0) $(".sort_dropDown").removeClass('active');
    if (!MobfilterContainer.is(e.target) && MobfilterContainer.has(e.target).length === 0) $(".product_filter_wpr").removeClass('show'), $('body').removeClass('overflow--hidden');
  });
  $('body').on('click','.header-mobile-icon button', function(){
    $('.header-left').addClass('show');
    $('body').addClass('overflow--hidden');
  });
  $('body').on('click','.nav_close_btn, .black-overlay', function(){
      $('.header-left').removeClass('show');
      $('body').removeClass('overflow--hidden');
  });
  $(document).mouseup(function(e){
    var activeDropDown = $(".dropdown.active");      
    if (!activeDropDown.is(e.target) && activeDropDown.has(e.target).length === 0){
      activeDropDown.removeClass('active');
    }
  });
  $('[data-modal-button]').on('click', function(e){
    e.preventDefault();
    var id = $(this).data('modal-id');
    $('[data-modal-popup][id="'+ id +'"]').addClass('show');
    $('body').addClass('overflow--hidden');
  });
  // Popup Js
  $('body').on('click','.popup .popup_close, .popup .mob_close_btn', function(e){ 
    $('.popup').removeClass('show');
    $('body').removeClass('overflow--hidden');
  });
  // Sort DropDown
  $('body').on('click','.filter_sort_btn button', function(){  
    $('.product_filter_wpr').addClass('show');
    $('body').addClass('overflow--hidden');
  });
  $('body').on('click','.product_filter_group .fs_close_icons', function(e){  
    e.preventDefault();
    $('.product_filter_wpr').removeClass('show');
    $('body').removeClass('overflow--hidden');
  });
  // product ATC
  $('body').on('click', '[data-close-cart]', function(e) {
      e.preventDefault();
      $('[data-cart-notification]').removeClass('popup--active').find('[data-cart-item]').empty();
      $('body').removeClass('overflow--hidden');
  });
  function cartNotification(product_url, section_id, key){
    var product_item_data = '[id="cart-notification-product-'+key+'"]';
    $.get(product_url+'?section_id='+section_id+'&t='+Math.random(), function(data){
      $('[data-cart-notification] [data-cart-item]').html($(data).find(product_item_data).html()).addClass('popup--active');
      
      $('[data-cart-notification]').addClass('popup--active');
      $('body').addClass('overflow--hidden');
      console.log('Added to cart');
      
      setTimeout(function(){
        $('[data-cart-notification]').removeClass('popup--active').find('[data-cart-item]').empty();
        $('body').removeClass('overflow--hidden');
      }, 2000);
    });
  }
  function changeCartData(section_id){
    // $.get('/cart?section_id='+section_id+'&t='+Math.random(), function(data){
    $.get("/cart?t=" + Math.random(), function (data) {
      $('[data-cart-item]').html($(data).find('[data-cart-item]').html());
      $(`.cart-recommendations`).html($(data).find(`.cart-recommendations`).html());
      console.log('Cart Updated');
      if ($(data).find('[data-cart-subtotal]')) {
        $('[data-cart-subtotal]').html($(data).find('[data-cart-subtotal]').html());
      }
      if ($(data).find('[data-cart-savings]')) {
        $('[data-cart-savings]').html($(data).find('[data-cart-savings]').html());
      }
    });
  }
  function activeCartCount(){
    jQuery.getJSON("/cart.js?t="+Math.random(), function(cart) {
      if (cart.item_count == 0) {
        $('.header-wrp [aria-label="cart"] .cart-count').hide();
        $('[data-cart-footer]').hide();
      } else {
        $('.header-wrp [aria-label="cart"] .cart-count').show();
        $('[data-cart-footer]').show();
      }
    });
  }
  function updateCart(_this, key, qty, section_id){
    $.ajax({
      type: "POST",
      url: window.routes.cart_change_url,
      dataType: "json",
      data: "quantity=" + parseInt(qty) + "&id=" + parseInt(key),
      success: function (data) {
        changeCartData(section_id);
        activeCartCount();
      },
      error: function (response) {
        _this.parents('.cart_items').find('.cart_price_remove').append('<p class="error">'+ response.responseJSON.errors +'</p>');
        setTimeout(function(){
          $('.error').remove();
        }, 5000);
      },
    });
  }
  $('body').on('submit', '[data-type="add-to-cart-form"]', function(e){
    e.preventDefault();
    $('.error').remove()
    var _this = $(this), btn = $(this).find('[name="add"] p'), btn_text = $(this).find('[name="add"] p').html();
    btn.html(window.variantStrings.adding);
    Shopify.addItemFromForm($(this).attr('id'), function(c){
      btn.html(btn_text);
      cartNotification(_this.data('product-url'), 'cart-notification-product', c.key);
      activeCartCount();
    });
  });
  // cart update
  $("body").on("click", ".quantity_decrement", function (e) {
    $('.error').remove();
    var _this = $(this), input = $(this).parent().find("input"), input_val = parseInt(input.val());
    if ($(this).attr('name') == "plus" ? (input_val += 1) : (input_val -= 1));
    input.val(input_val);
    var key = $(this).parent().find("input").data("id");
    updateCart($(this), key, input_val, _this.data('section-id'))
  });
  $("body").on("click", ".remove_pro", function (e) {
    e.preventDefault();
    $('.error').remove();
    var key = $(this).data("id");
    updateCart($(this), key, 0, $(this).data('section-id'));
  });
  // Load more products
  $('body').on('click', '.load_more', function(e){
    e.preventDefault();
    var loadingImage, scrollNode = $('.showmore_btn .load_more'), scrollUrl = $('.showmore_btn .load_more').attr("data-href");
    if(scrollNode.length > 0 && scrollUrl != '') {
      $.ajax({
        type: 'GET',
        url: scrollUrl,
        beforeSend: function() {
          $('.showmore_btn .load_more').addClass('loading-more').html('Loading...');
        },
        success: function(data) {
          var filteredData = $(data).find("[data-grid-html]").html(), load_btn = $(data).find(".showmore_btn").html();
          $("[data-grid-html]").append(filteredData);
          $(".showmore_btn").html(load_btn);
          $('.showmore_btn .load_more').removeClass('loading-more');
          if($('.showmore_btn .load_more').attr("data-href") == '') $('.showmore_btn').hide();
        },
        dataType: "html"
      });
    }
  });
});

// Contact form validation
$('body').on('click', '#contact_form .contact-btn', (e) => {
   e.preventDefault();
    var form = $(e.target).closest('form') ,fields = form.find('.form-input input, .form-input textarea');
    fields.each((i,field)=>{
       var val = $(field).val().trim()
        if(!val) {
          $(field).addClass('error')
          $(field).next(".err-msg" ).addClass('error')
        } else {
          $(field).removeClass('error')
          $(field).next(".err-msg" ).removeClass('error')
        }
      
      if($(field).attr('type') == 'email'){
        var emailvalue = $(field).val().trim() , emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(emailvalue)) {
           $(field).addClass('error')
           $(field).next(".err-msg" ).addClass('error')
        } else {
           $(field).removeClass('error')
           $(field).next(".err-msg" ).removeClass('error')
        }
      }
    })
   var error = form.find('.error')
   if(!error.length > 0){
     form.submit()
   }
});

const contactTrue = window.location.href.includes('contact_posted=true');
if(contactTrue) {
    setTimeout(() => {
        $('form .success_msg').remove();
        $('.form-input.success , .form-input.success').removeClass('success');
      
        if (history.pushState) {
          var newurl = window.location.protocol + "//" +window.location.host + window.location.pathname; 
          window.history.pushState({ path: newurl }, "", newurl);
        }
    }, 5000);
}

$(window).on("load", function () {
    var e = window.location.href, t = new URL(e).searchParams.get("scroll"), o = 0;
    if ($("#" + t).length) {
        let e = document.querySelector("#" + t),
            i = window.getComputedStyle(e, null).getPropertyValue("padding-top");
        $("html, body").animate({ scrollTop: $("#" + t).offset().top - o + parseInt(i) }, 1000);
    }
});